<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md12>
                <v-card title>
                    <v-card-title>
                        <h2>Usuarios</h2>
                    </v-card-title>
                    <v-card-text>
                        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <UsersDialog v-if="get_dialogMain.dialog" />
        <AssifnRoleToUserDialog :model="user" v-if="get_dialogSecoundMain.dialog && get_dialogSecoundMain.showtype == 'role'" />
        <UpdatePasswordUserDialog :model="user" v-if="get_dialogSecoundMain.dialog && get_dialogSecoundMain.showtype == 'password'" />

    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import UsersDialog from '@/components/dialogs/UsersDialog'
import AssifnRoleToUserDialog from '@/components/dialogs/AssifnRoleToUserDialog'
import UpdatePasswordUserDialog from '@/components/dialogs/UpdatePasswordUserDialog'

import router from '@/router'

export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'usr.add' }
        ],
        titles: [
          { text: 'Id', value: 'id', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Usuario', value: 'usuario', class: 'black--text' },
          { text: 'Email', value: 'email', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          { text: 'Fecha Actualizada', value: 'Updated' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'asignar role', icon: 'mdi-border-color', color: 'lime lighten-1', action: 'toAssignRole', code: 'usr.set-rol' },
          { title: 'asignaciones', icon: 'mdi-border-color', color: 'lime lighten-1', action: 'toMunicipiosAssign', code: 'usr.upd-assignments' },
          { title: 'Cambio de Contraseña', icon: 'mdi-account-key', color: 'lime lighten-1', action: 'toUpdatePassword', code: 'usr.chg-pass' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {}
  }),
  components: {
    DataTableMain,
    UsersDialog,
    AssifnRoleToUserDialog,
    UpdatePasswordUserDialog
  },
  mounted () {
    this.ShowPermisos(JSON.parse(localStorage.getItem('permisos')))
    this.getUrl('usr.list')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('usr.list')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    toAssignRole (item) {
      this.user = item.item
      this.SHOW_DIALOG_SECOUND_MAIN({ type: 'create', showtype: 'role' })
    },
    toUpdatePassword (item) {
      this.user = item.item
      this.SHOW_DIALOG_SECOUND_MAIN({ type: 'create', showtype: 'password' })
    },
    toMunicipiosAssign (item) {
      this.SET_DATA_SECOUND_MAIN(item.item)
      router.push({ name: 'ViewMunicipiosRoleAssign', params: { id: item.item.id } })
    },
    ...mapActions(['getUrlServices', 'postUrlServicesListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesListAction({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    ShowPermisos (permisos) {
      if (permisos.descripcion) {
        if (permisos.descripcion.special === 'all-access') {
          this.table.header.options.map(action => {
            action.hidden = ''
          })
          this.table.body.actions.map(action => {
            action.hidden = ''
          })
        } else {
          this.table.header.options.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })

          this.table.body.actions.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })
        }
      } else {
        this.table.header.options.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })

        this.table.body.actions.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SHOW_DIALOG_SECOUND_MAIN', 'CLEAR_DATAS_MAIN', 'SET_DATA_SECOUND_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_dialogSecoundMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('usr.list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATAS_MAIN()
  }

}
</script>

<style>

</style>
crear curd de roles
